import * as React from 'react'

import type { ShipmentActivityFeedItem } from '#/entities/shipment'
import { HistoryIcon } from '#/shared/ui/icons'
import { HistoryAppTag, NoteRow } from '#/shared/ui/history-row'

function activityMeta(activity: ShipmentActivityFeedItem): React.ReactNode[] {
  const meta: React.ReactNode[] = [activity.timestamp]
  if (activity.isSystemActor) {
    meta.push(<HistoryAppTag>{activity.actorName}</HistoryAppTag>)
  } else if (activity.actorName) {
    meta.push(activity.actorName)
  }
  return meta
}

export function ActivityHistoryRow({
  activity,
}: {
  activity: ShipmentActivityFeedItem
}) {
  return (
    <NoteRow
      icon={HistoryIcon}
      title={activity.text}
      meta={activityMeta(activity)}
    />
  )
}
